import ReactCalendar from "react-calendar";
import React from "react";
import "./calendar.css";
import styles from "./calendar.module.scss";
import dayjs from "dayjs";
import { useSwipeable } from "react-swipeable";
import Icon from "../../icons/Icon";
import {
  ChevronrightG900,
  ChevronleftG900,
  ChevronLeftDouble,
  ChevronRightDouble,
} from "../../icons/18";
import { useState } from "react";

export const Calendar = ({
  customTile,
  ...otherProps
}: {
  customTile?: React.ReactNode;
  [key: string]: any;
}) => {
  const calendar = React.useRef<HTMLInputElement | null>(null);

  const handlers = useSwipeable({
    onSwipedLeft(_) {
      const btn = calendar.current?.getElementsByClassName(
        "react-calendar__navigation__next-button",
      )[0];
      if (btn) {
        (btn as HTMLButtonElement).click();
      }
    },
    onSwipedRight(_) {
      const btn = calendar.current?.getElementsByClassName(
        "react-calendar__navigation__prev-button",
      )[0];
      if (btn) {
        (btn as HTMLButtonElement).click();
      }
    },
  });

  const tileContent = ({
    date,
    view,
  }: {
    date: Date;
    view: "month" | "year" | "decade" | "century";
  }): JSX.Element | null => {
    if (customTile) {
      return <>{customTile}</>;
    } else {
      if (view === "month") {
        return (
          <span className="calendar-month-tile-custom">
            <i>{date.getDate()}</i>
          </span>
        );
      }
    }
    return null;
  };

  const [calendarView, setCalendarView] = useState("month");

  return (
    <div
      className={`${styles["calendar"]} ${styles[calendarView]} sharedui-calendar`}
      {...handlers}
    >
      <ReactCalendar
        {...otherProps}
        inputRef={calendar}
        nextLabel={<Icon IconComponent={<ChevronrightG900 />} size={18} />}
        prevLabel={<Icon IconComponent={<ChevronleftG900 />} size={18} />}
        prev2Label={<Icon IconComponent={<ChevronLeftDouble />} size={18} />}
        next2Label={<Icon IconComponent={<ChevronRightDouble />} size={18} />}
        calendarType="US"
        tileContent={tileContent}
        formatDay={(_, date) => `${dayjs(date).format("D")}`}
        minDetail="year"
        maxDetail="month"
        defaultView="month"
        onActiveStartDateChange={({ view }) => setCalendarView(view)}
      />
    </div>
  );
};
